<template>
  <div class="d-flex checkin-status-select">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="text-center widget-item variant"
      :class="{ selected: value === item.value }"
      @click="$emit('input', item.value)"
      :data-variant="getVariant(item)"
      data-apply-color
      data-apply-border-color
      :data-apply-bg-color="value === item.value"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
import { VARIANT_MAP } from '@/constants/common'

/**
 * This component can be used to select KR status while checking-in
 * Statuses are shown as buttons and user can click on the button to select it
 *
 * props:
 *   - items: Array of {label, value}
 *   - v-model
 *   - value: String
 *      (Generally value is not required if you are using v-model)
 * emits:
 *   - @input: (value) => {}
 *      (Generally @input is not required if you are using v-model)
 */
export default {
  name: 'CheckinStatusSelectButtons',
  props: ['items', 'value'],
  methods: {
    getVariant({ type }) {
      return VARIANT_MAP['status-' + type]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/goals';

.checkin-status-select .widget-item {
  cursor: pointer;
  border-radius: 20px;
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
  text-align: center;
  padding: 0 10px;
  transition: all ease-out 200ms;

  &:not(:last-child) {
    margin-right: 10px;
  }

  .label {
    white-space: nowrap;
    color: #c4c4c4;
    transition: all ease-in 200ms;
  }

  &.selected {
    color: $documentColor;
  }
}
</style>
